import React, {useMemo} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {LatLng} from 'leaflet';
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import LeafletPolyline from '@ui/leafletCustom/leafletPolyline/LeafletPolyline';


const PositionsMutateSingleVoyage = ({opacity}: { opacity?: number }) => {

    const {positions} = useRootContextMutateSingleVoyage()
    const {theme} = useThemeContext()

    const currentPositions = useMemo(() => {
        if (!positions?.length) {
            return []
        }
        return positions.map((point) => {
            return new LatLng(point.lat, point.lng)
        })

    }, [positions])

    const pathOptions = useMemo(() => {
        return {
            weight: 7,
            color: theme === 'dark' ? '#fff' : '#222',
            opacity: opacity ?? 1,
        }
    }, [theme, opacity])

    return (
        <LeafletPolyline
            positions={currentPositions}
            pathOptions={pathOptions}
        />
    );
};

export default PositionsMutateSingleVoyage;